import styled from 'styled-components';
import { HeColours } from '../../common/styles/HeColours';
import { PAGE_CONTAINER, PAGE_SIDE_PADDING } from '../../common/styles/Layout';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { Breakpoint } from '../../common/styles/constants';
import { onMobile } from '../../common/styles/onMobile';
import { responsiveInterpolate } from '../../common/styles/responsiveInterpolate';

export const ResultViewDisplay = styled.div<{ useOffset?: boolean }>`
  background-color: ${ThemeColours.mono100};
  min-height: 880px;
  overflow: auto;
  position: relative;
  top: ${({ useOffset }) => (useOffset ? responsiveInterpolate(52, 72) : 0)};

  ${Breakpoint.SMALL} {
    background-color: ${HeColours.gray[50]};
  }
`;

export const Inner = styled.div`
  ${PAGE_CONTAINER};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-left: 0;
  padding-right: 0;

  ${Breakpoint.SMALL} {
    padding-left: ${PAGE_SIDE_PADDING};
    padding-right: ${PAGE_SIDE_PADDING};
  }
`;

export const List = styled.div`
  width: auto;

  ${onMobile} {
    width: 100%;
  }
`;
